/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Walkthrough_P3_1_Day_Before_TrailInputs */

const en_subscription_walkthrough_p3_1_day_before_trail = /** @type {(inputs: Subscription_Walkthrough_P3_1_Day_Before_TrailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 days before`)
};

const ar_subscription_walkthrough_p3_1_day_before_trail = /** @type {(inputs: Subscription_Walkthrough_P3_1_Day_Before_TrailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قبل 2 أيام`)
};

const de_subscription_walkthrough_p3_1_day_before_trail = /** @type {(inputs: Subscription_Walkthrough_P3_1_Day_Before_TrailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 Tage vorher`)
};

const es_subscription_walkthrough_p3_1_day_before_trail = /** @type {(inputs: Subscription_Walkthrough_P3_1_Day_Before_TrailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 días antes`)
};

const fr_subscription_walkthrough_p3_1_day_before_trail = /** @type {(inputs: Subscription_Walkthrough_P3_1_Day_Before_TrailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 jours avant`)
};

const it_subscription_walkthrough_p3_1_day_before_trail = /** @type {(inputs: Subscription_Walkthrough_P3_1_Day_Before_TrailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 giorni prima`)
};

const ja_subscription_walkthrough_p3_1_day_before_trail = /** @type {(inputs: Subscription_Walkthrough_P3_1_Day_Before_TrailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2日前`)
};

const ko_subscription_walkthrough_p3_1_day_before_trail = /** @type {(inputs: Subscription_Walkthrough_P3_1_Day_Before_TrailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2일 전`)
};

const pt_br_subscription_walkthrough_p3_1_day_before_trail = /** @type {(inputs: Subscription_Walkthrough_P3_1_Day_Before_TrailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 dias antes`)
};

const ru_subscription_walkthrough_p3_1_day_before_trail = /** @type {(inputs: Subscription_Walkthrough_P3_1_Day_Before_TrailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`За 2 дня`)
};

const th_subscription_walkthrough_p3_1_day_before_trail = /** @type {(inputs: Subscription_Walkthrough_P3_1_Day_Before_TrailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 วันล่วงหน้า`)
};

const tr_subscription_walkthrough_p3_1_day_before_trail = /** @type {(inputs: Subscription_Walkthrough_P3_1_Day_Before_TrailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 gün önce`)
};

const zh_cn_subscription_walkthrough_p3_1_day_before_trail = /** @type {(inputs: Subscription_Walkthrough_P3_1_Day_Before_TrailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`试用结束前 2 天`)
};

const zh_tw_subscription_walkthrough_p3_1_day_before_trail = /** @type {(inputs: Subscription_Walkthrough_P3_1_Day_Before_TrailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`試用結束前 2 天`)
};

/**
* | output |
* | --- |
* | "2 days before" |
*
* @param {Subscription_Walkthrough_P3_1_Day_Before_TrailInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_walkthrough_p3_1_day_before_trail = /** @type {((inputs?: Subscription_Walkthrough_P3_1_Day_Before_TrailInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Walkthrough_P3_1_Day_Before_TrailInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_walkthrough_p3_1_day_before_trail(inputs)
	if (locale === "ar") return ar_subscription_walkthrough_p3_1_day_before_trail(inputs)
	if (locale === "de") return de_subscription_walkthrough_p3_1_day_before_trail(inputs)
	if (locale === "es") return es_subscription_walkthrough_p3_1_day_before_trail(inputs)
	if (locale === "fr") return fr_subscription_walkthrough_p3_1_day_before_trail(inputs)
	if (locale === "it") return it_subscription_walkthrough_p3_1_day_before_trail(inputs)
	if (locale === "ja") return ja_subscription_walkthrough_p3_1_day_before_trail(inputs)
	if (locale === "ko") return ko_subscription_walkthrough_p3_1_day_before_trail(inputs)
	if (locale === "pt_br") return pt_br_subscription_walkthrough_p3_1_day_before_trail(inputs)
	if (locale === "ru") return ru_subscription_walkthrough_p3_1_day_before_trail(inputs)
	if (locale === "th") return th_subscription_walkthrough_p3_1_day_before_trail(inputs)
	if (locale === "tr") return tr_subscription_walkthrough_p3_1_day_before_trail(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_walkthrough_p3_1_day_before_trail(inputs)
	return zh_tw_subscription_walkthrough_p3_1_day_before_trail(inputs)
});